import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"

import Flickity from 'flickity';
import { Fancybox } from "@fancyapps/ui";

import 'flowbite';

//import 'tw-elements';

gsap.registerPlugin(ScrollTrigger);

// It's best to inline this in `head` to avoid FOUC (flash of unstyled content) when changing pages or themes
if (
    localStorage.getItem('color-theme') === 'dark' ||
    (!('color-theme' in localStorage) &&
        window.matchMedia('(prefers-color-scheme: dark)').matches)
) {
    document.documentElement.classList.add('dark');
} else {
    document.documentElement.classList.remove('dark');
}

window.addEventListener('load', function() {
    /* gsap.to(".box1", {
         scrollTrigger: {
             trigger: '.box1',
             start: 'top center',
             //  markers: true,
             toggleActions: 'restart pause reverse pause'
         },

         rotation: 360,
         x: 500,
         duration: 3
     });
     gsap.to(".box2", {
         scrollTrigger: {
             trigger: '.box2',
             start: 'top center',
             // markers: true,
             toggleActions: 'restart pause reverse pause',
             scrub: true
         },

         ease: 'none',
         x: 1200,
         duration: 3
     });*/


    var elem = document.querySelector('.carousel-store');
    var flkty = new Flickity(elem, {
        wrapAround: true,
        autoPlay: 3000,
        contain: true,
        // disable previous & next buttons and dots
        prevNextButtons: false,
        pageDots: false

    });

    const siteNavigation = document.getElementById('site-navigation');
    const burger = document.getElementById('burger');
    const closeMenuBtn = document.getElementById('closeMenuBtn');
    const page = document.getElementById('page');
    const secondaryNav = document.getElementById('secondaryNav');

    var closeMenu = document.getElementsByClassName("closeMenu");

    for (var i = 0; i < closeMenu.length; i++) {
        closeMenu[i].addEventListener("click", function() {
            siteNavigation.classList.add('opacity-0', 'pointer-events-none');
            secondaryNav.classList.remove('hidden');
            closeMenuBtn.classList.add('hidden');
            document.body.classList.remove('overflow-hidden');
        });
    }

    var openMenu = document.getElementsByClassName("openMenu");

    for (var i = 0; i < openMenu.length; i++) {
        openMenu[i].addEventListener("click", function() {
            siteNavigation.classList.remove('opacity-0', 'pointer-events-none');
            secondaryNav.classList.add('hidden');
            closeMenuBtn.classList.remove('hidden');
            document.body.classList.add('overflow-hidden');
        });
    }

    var readMore = document.getElementsByClassName("readMore");
    for (var i = 0; i < readMore.length; i++) {
        readMore[i].addEventListener("click", function() {

            var textBlock = this.closest('.textBlock');
            // let myModal = 

            var myText = textBlock.getElementsByClassName('myText');
            var requiredElement = myText[0];
            if (requiredElement.classList.contains('line-clamp-3')) {
                requiredElement.classList.remove('line-clamp-3');
                this.classList.add('hidden');
            } else {
                requiredElement.classList.add('line-clamp-3');
            }
        });
    }

    //////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////
    //////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////
    //////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////
    //////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////

    var themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
    var themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');

    // Change the icons inside the button based on previous settings
    if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
        themeToggleLightIcon.classList.remove('hidden');
    } else {
        themeToggleDarkIcon.classList.remove('hidden');
    }

    var themeToggleBtn = document.getElementById('theme-toggle');

    themeToggleBtn.addEventListener('click', function() {

        localStorage.setItem('theme-set', 'manual');

        // toggle icons inside button
        themeToggleDarkIcon.classList.toggle('hidden');
        themeToggleLightIcon.classList.toggle('hidden');

        // if set via local storage previously
        if (localStorage.getItem('color-theme')) {
            if (localStorage.getItem('color-theme') === 'light') {
                document.documentElement.classList.add('dark');
                localStorage.setItem('color-theme', 'dark');
            } else {
                document.documentElement.classList.remove('dark');
                localStorage.setItem('color-theme', 'light');
            }

            // if NOT set via local storage previously
        } else {
            if (document.documentElement.classList.contains('dark')) {
                document.documentElement.classList.remove('dark');
                localStorage.setItem('color-theme', 'light');
            } else {
                document.documentElement.classList.add('dark');
                localStorage.setItem('color-theme', 'dark');
            }
        }

    });

    // add 
    // localStorage.setItem('theme-set', 'manual');

    function isOdd(num) { 
        return num % 2;
    }

    function checkTheme() { 
        const d = new Date();
        let hour = d.getHours();
        //let hour = d.getSeconds();
        console.log(hour); 
        if (localStorage.getItem('theme-set') === 'auto' || (!('theme-set' in localStorage))) {
            if (hour > 8 && hour < 20) { 
            //if (isOdd(hour)) { 
                // Light 
                console.log('Light');
                themeToggleDarkIcon.classList.remove('hidden');
                themeToggleLightIcon.classList.add('hidden');
                document.documentElement.classList.remove('dark');
                localStorage.setItem('color-theme', 'light');
                localStorage.setItem('theme-set', 'auto');
            } else { 
                // Dark
                console.log('Dark');
                themeToggleLightIcon.classList.remove('hidden');
                themeToggleDarkIcon.classList.add('hidden');
                document.documentElement.classList.add('dark');
                localStorage.setItem('color-theme', 'dark');
                localStorage.setItem('theme-set', 'auto');
            }
        }

    }
    checkTheme();
    //setInterval(checkTheme, 60 * 1000);
    setInterval(checkTheme, 1000);

    //////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////
    //////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////
    //////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////


});